module.exports = __webpack_public_path__ + "img/VisionVF.27a5353e.jpg";